import { ClpInitConfig, LoginAlertModel } from '@reef/login';
import { LoggedInUser, AmaRequestData } from '../../service/model';
import { ConfigurationOutput } from '@reef/core';

export const CORE_FEATURE = 'coreUppUi';

export interface CoreState {
  clpUrl?: string;
  clpConfig?: ClpInitConfig;
  loggedIn: boolean;
  user?: LoggedInUser;
  error?: LoginAlertModel;
  sending: boolean;
  configuration?: ConfigurationOutput;
  amaRequestData?: AmaRequestData;
}

export const coreInitialState: CoreState = {
  loggedIn: false,
  sending: false
};
